const Home = () => {
    return (
        <div className="mb-auto box-border w-auto h-auto p-4 m-10 border-2 bg-white/75">
            <h2 className="text-3xl m-3">Hello MixEls!</h2>
            <p>Feeling tired of not knowing what to mix for your cocktail nights?</p> <br />
            <p>If what you need is some inspiration, you got to the right place. <br />
            In MixElixir you just need to think of an ingredient and we will give you the best cocktail list</p>
        </div>
    )
}

export default Home